import { inject, Injectable } from '@angular/core';

import { DragDropConfig } from '../../config/drag-drop-config';
import type { SortableContainer } from '../../sortable-container.model';
import { isPresent } from '../../util/is-present';

@Injectable({ providedIn: 'root' })
export class DragDropSortableService {
  private config = inject(DragDropConfig);

  /**
   * The last element that was marked sortable.
   *
   * @memberof DragDropSortableService
   */
  private _element: HTMLElement;

  index: number;

  sortableContainer: SortableContainer;

  isDragged: boolean;

  /**
   * Gets the last element that was marked sortable.
   *
   * @readonly
   * @memberof DragDropSortableService
   */
  get element(): HTMLElement {
    return this._element;
  }

  /**
   * Assigns the `onSortableDragClass` to the given element.
   *
   * @param e The element to assign the CSS class to.
   * @memberof DragDropSortableService
   */
  markSortable(e: HTMLElement): void {
    if (isPresent(this._element)) {
      this._element.classList.remove(this.config.onSortableDragClass);
    }

    if (isPresent(e)) {
      this._element = e;
      this._element.classList.add(this.config.onSortableDragClass);
    }
  }
}
